class HeaderSearch extends HTMLElement {
  constructor() {
    super()
    this.isOpen = false
    this.searchInput = null
    this.searchIcon = null
    this.searchText = null
    this.searchForm = null
  }

  connectedCallback() {
    this.searchIcon = this.querySelector('[data-search-icon]')
    this.searchText = this.querySelector('[data-search-text]')

    // Create form element
    this.searchForm = document.createElement('form')
    this.searchForm.role = 'search'
    this.searchForm.method = 'get'
    this.searchForm.action = '/'
    this.searchForm.className = 'w-0 opacity-0 transition-all duration-300 ease-in-out'

    // Create input element
    this.searchInput = document.createElement('input')
    this.searchInput.type = 'search'
    this.searchInput.name = 's'
    this.searchInput.placeholder = 'Search...'
    this.searchInput.className = 'w-full outline-none bg-transparent paragraph-md font-regular'

    // Add input to form
    this.searchForm.appendChild(this.searchInput)

    // Add event listeners
    this.addEventListener('click', this.toggleSearch.bind(this))
    this.searchInput.addEventListener('blur', this.closeSearch.bind(this))
    this.searchInput.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        this.closeSearch()
      }
    })

    if (this.searchIcon) {
      // Add click handler for the search icon
      this.searchIcon.addEventListener('click', e => {
        e.stopPropagation() // Prevent toggleSearch from being called
        if (this.searchInput.value.trim()) {
          this.searchForm.submit()
        } else {
          this.openSearch()
        }
      })
    }
  }

  toggleSearch() {
    if (!this.isOpen) {
      this.openSearch()
    }
  }

  openSearch() {
    this.isOpen = true
    this.classList.add('search-open')

    // Insert form after the text
    this.searchText.after(this.searchForm)

    // Trigger reflow
    this.searchForm.offsetWidth

    // Animate form
    this.searchForm.style.width = '100px'
    this.searchForm.style.opacity = '1'
    this.searchInput.focus()

    // Hide text and icon
    this.searchText.style.opacity = '0'
    // this.searchIcon.style.opacity = '0';
  }

  closeSearch() {
    if (!this.isOpen) return

    this.isOpen = false
    this.classList.remove('search-open')

    // Animate form
    this.searchForm.style.width = '0'
    this.searchForm.style.opacity = '0'

    // Show text and icon
    this.searchText.style.opacity = '1'
    this.searchIcon.style.opacity = '1'

    // Remove form after animation
    setTimeout(() => {
      if (this.searchForm.parentNode) {
        this.searchForm.parentNode.removeChild(this.searchForm)
      }
    }, 300)
  }
}

if (!customElements.get('header-search')) {
  customElements.define('header-search', HeaderSearch)
}
